import { Component, OnInit, Input, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators} from '@angular/forms';
import { HttpService } from '../../services/http/http.service';
import { LoaderService } from '../../services/loader/loader.service';
import { FADE_IN } from '../../util/animations/animation';
import { ToastrService } from 'ngx-toastr';
import * as moment from 'moment';
/**
 * This component is used to display the patient details.
 * 
 * This is a reusable component, we have used this same component for 
 * 
 * 1. Add patient detail
 * 
 * 2. Edit patient detail
 * 
 * 3. View patient detail
 */
@Component({
  selector: 'app-summary',
  templateUrl: './summary.component.html',
  styleUrls: ['./summary.component.scss'],
  animations: [FADE_IN]
})
export class SummaryComponent implements OnInit {
  patientForm: FormGroup;
  @Input() isEdit = false;
  @Input() patientId;
  @Input() patientDetails:any = {};
  @Input() config:any = {};
  @Output() public onSuccess = new EventEmitter();
  placeholders = {
    email: 'Email',
    phone: 'Phone number'
  }

  constructor(private FB: FormBuilder,
    private httpService: HttpService,
    private loader: LoaderService,
    private toastr: ToastrService) { }

  ngOnInit() {
    this.isValidEmail();
    this.isValidPhone();
    this.generatePatientForm();
    this.patientForm.patchValue(this.patientDetails)
  }

  ngOnChanges(changes: SimpleChanges) {
    if(this.patientForm)
      this.patientForm.patchValue(changes.patientDetails.currentValue);
  }

  generatePatientForm(){
    this.patientForm = this.FB.group({
      fname: ['', [Validators.required]],
      lname: ['', [Validators.required]],
      birthDate: [''],
      phone: [''],
      email: [''],
      mrn: [''],
      addrLine1: [''],
      addrLine2: [''],
      city: [''],
      state: [''],
      postalCode: ['']
    })
  }

  onEdit(){
    this.isEdit = !this.isEdit;
    this.patientForm.reset();
    this.patientForm.patchValue(this.patientDetails);
  }

  /**
   * This function gets called while adding a new patient or editing the existing patient
   */
  onFormSubmit(){
    if(this.patientForm.valid){
      this.loader.show('progress');
      const payload = {
        ...this.patientForm.value
      }
      payload.birthDate = payload.birthDate? moment(payload.birthDate).format('YYYY-MM-DD') : "";
      payload.email = payload.email? payload.email : "";
      payload.phone = payload.phone? payload.phone : "";
      let url = 'patient';
      if(this.config.editOption){
        payload.id = this.patientId;
        url += `/${this.patientId}`;
      }
       
      this.httpService.post(url, payload)
        .subscribe((response: any) => {
          this.loader.hide('progress');
          this.onSuccess.emit(true);
          if(this.config.editOption){
            this.onEdit();
          }
        }, error =>{
          this.loader.hide('progress');
          this.toastr.warning(error, 'Patients', {
            progressBar: true, timeOut: 3000
          });
        })
    } 
  }

  /**
   * This function is used to show the validation message for email
   */
  isValidEmail(){
    const stats = this.patientDetails.emailStats;
    if(stats&&stats.emailValid){
          this.placeholders.email = `Email **(${stats.score*100}% of chances for valid email)**`
    }else if(stats&&!stats.emailValid){
      if((stats.score*100)<100){
        this.placeholders.email = 'Email **(Undeliverable email address)**'
      }
    }
  }

   /**
   * This function is used to show the validation message for phone
   */
  isValidPhone(){
    const stats = this.patientDetails.mobileStats;
    if(stats&&stats.mobileValid){
      this.placeholders.phone = `Phone number (${this.patientDetails.mobileStats.carrier})`
    }else if(stats&&!stats.mobileValid){
      this.placeholders.phone = 'Phone number **(Not a mobile phone)**'
    }
  }
}
